import theme from '../../style/theme';

/**
 * Skeleton color tokens.
 *
 * - bone: Placeholder grey from theme form inputs (#B8B8B8 across all brands).
 * - border: Matches BaseTile/CartLineItem border color (#CCC).
 * - cardBackground: Matches BaseTile background (white).
 *
 * NOTE: border and cardBackground use hardcoded values matching the real components
 * (BaseTile.tsx:125, CartLineItemLoyaltyEnabled.tsx). The theme doesn't have tile-specific
 * tokens yet. If `colour.skeleton.*` tokens are added to brand themes, switch to those.
 */
export const getSkeletonColors = () => ({
  bone: theme.colour.text.form.textInput.placeholder,
  border: '#CCC',
  cardBackground: '#FFFFFF',
});

/** Stagger presets — apply as animationDelay props on each bone */
export const STAGGER = {
  /** Standard stagger interval between sibling bones */
  interval: 50,
  /** Helper to calculate delay for nth bone in a group */
  delay: (index: number) => index * 50,
} as const;

/** Text skeleton dimensions per variant */
export const TEXT_DIMENSIONS = {
  h1: {height: 14, borderRadius: 3, defaultWidth: '100%' as const},
  body: {height: 12, borderRadius: 2, defaultWidth: '100%' as const},
  caption: {height: 10, borderRadius: 2, defaultWidth: '60%' as const},
  price: {height: 20, borderRadius: 3, defaultWidth: '70%' as const},
} as const;

/** Image skeleton dimensions per variant */
export const IMAGE_DIMENSIONS = {
  product: {width: 90 as number | `${number}%`, height: 110, borderRadius: 6},
  banner: {width: '100%' as number | `${number}%`, height: 160, borderRadius: 0},
  thumbnail: {width: 80 as number | `${number}%`, height: 90, borderRadius: 6},
} as const;

/** Button skeleton dimensions per variant */
export const BUTTON_DIMENSIONS = {
  primary: {height: 40, borderRadius: 4},
  large: {height: 48, borderRadius: 6},
} as const;

/** Badge skeleton dimensions */
export const BADGE_DIMENSIONS = {
  width: 110,
  height: 22,
  borderRadius: 3,
} as const;

/** Stepper skeleton dimensions */
export const STEPPER_DIMENSIONS = {
  buttonSize: 36,
  counterWidth: 40,
  gap: 2,
  borderRadius: 4,
} as const;
